import { nanoid } from "@reduxjs/toolkit";
import { IconChevronRight, IconClock } from "@tabler/icons-react";
import { motion } from "framer-motion";
import React from "react";
import { Link, useMatch, useSearchParams } from "react-router-dom";
import Button from "src/components/UI/Button/Button";
import { useDeviceContext } from "src/context/device-context";
import { useLocaleContext } from "src/context/locale-context";
import { CLICK_ACTION } from "src/pages/CheapFlights";
import { formatFlightDate } from "src/utils/cheap-flights";
import { getTimeDifferenceInDays } from "src/utils/date-utils";
import { getPluralizedCaseCode } from "src/utils/trip-utils";

export function FlightDealsList({ deals, type, itemAction }) {
  const { isMobile } = useDeviceContext();
  const [searchParams] = useSearchParams();
  const matches = useMatch("/cheap-flights/:type/:src/*");
  const suffixedPath = matches?.params["*"];
  console.log(suffixedPath);
  const { getStringRes, currencySymbol, currentLocale } = useLocaleContext();
  const lang = currentLocale.split("_")[0].toUpperCase();

  return (
    <>
      {deals.map((flight) => {
        const tripDaysCount =
          type === "rt" &&
          getTimeDifferenceInDays(flight.return.timestamp, flight.departure.timestamp);

        let daysLeftText = getStringRes(
          `dashboard.trips.daysToGo_${getPluralizedCaseCode(tripDaysCount)}`
        ).replace("##DAYS_NUM##", tripDaysCount);
        let parts = daysLeftText.match(/(\d+)\s*([\u0400-\u04FFa-zA-Z])/u);
        daysLeftText = parts ? `${parts[1]} ${parts[2].toLowerCase()}.` : daysLeftText;

        const suffix = suffixedPath
          ?.split("/")
          .filter((p) => p.toLowerCase() !== flight.dest.iata.toLowerCase())
          .join("/");
        const itemLink =
          itemAction === CLICK_ACTION.START_SEARCH
            ? flight.link
            : `/cheap-flights/${type}/${flight.src.iata}/${flight.dest.iata}${
                suffix ? `/${suffix}` : ""
              }?${searchParams.toString()}`;

        return (
          <motion.div
            whileTap={{ scale: 0.95 }}
            className="results-grid-item"
            key={flight.id}
            tabIndex={-1}>
            <Link className="results-grid-item flight-card" to={itemLink}>
              <div className={`flight-route ${type === "rt" ? "rt" : "ow"}`}>
                <span className="cities">
                  {flight.src.city} → {flight.dest.city}
                </span>
                <div className="flight-header">
                  <div className="airline-info">
                    <div data-tooltip-id={nanoid()} data-tooltip-content={flight.airline}>
                      <div className="airline-icon">
                        <img src={flight.airlineIcon} alt={flight.airline} />
                      </div>
                    </div>
                  </div>
                </div>
                <span className="dates">
                  {formatFlightDate(flight.departure.timestamp, lang)}
                  {type === "rt" && ` - ${formatFlightDate(flight.return?.timestamp, lang)}`}
                </span>

                {!isMobile && type === "rt" && (
                  <span
                    className="time-indicator"
                    style={{ display: "flex", alignItems: "center", gap: "0.12rem" }}>
                    <IconClock size={13} />
                    {daysLeftText}
                  </span>
                )}

                <span className={flight.stopNum === 0 ? "stops direct" : "stops"}>
                  {flight.stopNum === 0 ? getStringRes("res.result.stop.none") : null}
                </span>
              </div>
              <div className="flight-price">
                <span>{getStringRes("cheap.flights.price.from")}</span>
                {` ${currencySymbol}${flight.price}`}
              </div>
              <Button tabIndex={-1} name={<IconChevronRight />} />
            </Link>
          </motion.div>
        );
      })}
    </>
  );
}
